import React from "react";

const users = [
  {
    id: "001",
    name: "Ah Tony",
    imageUrl: "https://i.pravatar.cc/80?img=1",
    storyCount: 3,
    viewedStoryCount: 2,
  },
  {
    id: "002",
    name: "M Residence",
    imageUrl: "https://i.pravatar.cc/80?img=2",
    storyCount: 2,
    viewedStoryCount: 2,
  },
  {
    id: "003",
    name: "Mo Lima",
    imageUrl: "https://i.pravatar.cc/80?img=3",
    storyCount: 1,
    viewedStoryCount: 0,
  },
  {
    id: "004",
    name: "John Doe",
    imageUrl: "https://i.pravatar.cc/80?img=4",
    storyCount: 20,
    viewedStoryCount: 2,
  },
  {
    id: "005",
    name: "Sarah Lee",
    imageUrl: "https://i.pravatar.cc/80?img=5",
    storyCount: 2,
    viewedStoryCount: 1,
  },
  {
    id: "006",
    name: "Michael",
    imageUrl: "https://i.pravatar.cc/80?img=6",
    storyCount: 3,
    viewedStoryCount: 0,
  },
  {
    id: "007",
    name: "Emily",
    imageUrl: "https://i.pravatar.cc/80?img=7",
    storyCount: 1,
    viewedStoryCount: 1,
  },
  {
    id: "008",
    name: "Daniel",
    imageUrl: "https://i.pravatar.cc/80?img=8",
    storyCount: 0,
    viewedStoryCount: 0,
  },
];

const ProfileStory = ({
  imageUrl,
  name,
  storyCount,
  viewedStoryCount,
}: {
  imageUrl: string;
  name: string;
  storyCount: number;
  viewedStoryCount: number;
}) => {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const segmentSize = circumference / storyCount;
  const spaceBetweenSegments = 7;
  const adjustedSegmentSize = segmentSize - spaceBetweenSegments;

  return (
    <div className="relative w-24 h-24 p-2">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
        {Array.from({ length: storyCount }).map((_, index) => {
          const isViewed = index < viewedStoryCount;
          const offset = index * segmentSize; // Position each segment
          return (
            <circle
              key={index}
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke={isViewed ? "#a1a1aa" : "url(#gradient)"} // Gray if viewed, green if unviewed
              strokeWidth="4"
              strokeDasharray={`${adjustedSegmentSize} ${
                circumference - adjustedSegmentSize
              }`}
              strokeDashoffset={-offset} // Position segment correctly
              strokeLinecap="round"
            />
          );
        })}

        {/* Gradient Definition */}
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4ade80" /> {/* Green */}
            <stop offset="100%" stopColor="#3b82f6" /> {/* Blue */}
          </linearGradient>
        </defs>
      </svg>

      {/* Profile Image */}
      <div className="w-full h-full rounded-full overflow-hidden border-2 border-black">
        <img
          src={imageUrl}
          alt="Profile"
          className="w-full h-full object-cover rounded-full"
        />
      </div>
    </div>
  );
};

export default function StoryList() {
  return (
    <div className="flex flex-wrap justify-center gap-6 bg-gray-900 p-6">
      {users.map((user) => (
        <ProfileStory
          key={user.id}
          imageUrl={user.imageUrl}
          name={user.name}
          storyCount={user.storyCount}
          viewedStoryCount={user.viewedStoryCount}
        />
      ))}
    </div>
  );
}

